module.exports = __webpack_public_path__ + "media/images/iconSearch__accent--dark-f192987d1d1b3aaf9e7a30cc64cd3cb3.png";